import createApiClient from "./api";

const api = createApiClient();

export async function generateInvoicePdf(projectId, contractId, invoice) {
  const response = await api.post(
    `/projects/${projectId}/contracts/${contractId}/invoice-pdf`,
    invoice,
    {
      responseType: "blob",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return response.data;
}

export async function fetchContracts(
  projectId,
  page = 1,
  pageSize = 10,
  filters,
  sortField = null,
  sortOrder = null
) {
  const token = localStorage.getItem("token");
  const response = await api.get(`/projects/${projectId}/contracts`, {
    params: {
      project_id: projectId,
      skip: (page - 1) * pageSize,
      limit: pageSize,
      filters: JSON.stringify(filters),
      ...(sortField && sortOrder
        ? { sort_field: sortField, sort_order: sortOrder }
        : {}),
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function fetchContract({ contractId, projectId }) {
    const token = localStorage.getItem("token");
    const response = await api.get(
      `/projects/${projectId}/contracts/${contractId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  return response.data;
}

export async function createContract(contract) {
  const token = localStorage.getItem("token");
  const project_id = contract?.project_id;
  const response = await api.post(
    `/projects/${project_id}/contracts`,
    contract,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function updateContract(contractId, contract) {
  const token = localStorage.getItem("token");
  const project_id = contract?.project_id;

  const response = await api.put(
    `/projects/${project_id}/contracts/${contractId}`,
    contract,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
}

export async function deleteContract(projectId, contractId) {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `/projects/${projectId}/contracts/${contractId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function fetchNextContractNumber({ projectId }) {
  const token = localStorage.getItem("token");
  const response = await api.get(`/projects/${projectId}/contracts/number`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function fetchChangeOrders(
  contractId,
  projectId,
  page = 1,
  pageSize = 10
) {
  const token = localStorage.getItem("token");
  const response = await api.get(
    `/projects/${projectId}/contracts/${contractId}/change-orders`,
    {
      params: {
        project_id: projectId,
        contract_id: contractId,
        skip: (page - 1) * pageSize,
        limit: pageSize,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function fetchChangeOrder({
  contractId,
  changeOrderId,
  projectId,
}) {
  const token = localStorage.getItem("token");
  const response = await api.get(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function createChangeOrder({
  contractId,
  changeOrderData,
  projectId,
}) {
  const token = localStorage.getItem("token");
  const response = await api.post(
    `/projects/${projectId}/contracts/${contractId}/change-orders`,
    changeOrderData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function updateChangeOrder({
  contractId,
  changeOrderData,
  projectId,
  changeOrderId,
}) {
  const token = localStorage.getItem("token");
  const response = await api.patch(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}`,
    changeOrderData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function deleteChangeOrder({
  contractId,
  changeOrderId,
  projectId,
}) {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function fetchNextChangeOrderNumber({ projectId }) {
  const token = localStorage.getItem("token");
  const response = await api.get(
    `/projects/${projectId}/contracts/change-orders/number`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function fetchAllChangeOrders(
  projectId,
  page = 1,
  pageSize = 10,
  filters,
  options = {}
) {
  const {
    isExportPdf = false,
    sortField = null,
    sortOrder = null,
    party = null,
  } = options;
  const token = localStorage.getItem("token");
  const response = await api.get(
    `/projects/${projectId}/contracts/all-change-orders`,
    {
      params: {
        project_id: projectId,
        skip: (page - 1) * pageSize,
        limit: pageSize,
        filters: JSON.stringify(filters),
        ...(isExportPdf ? { is_export_pdf: true } : {}),
        ...(sortField && sortOrder
          ? { sort_field: sortField, sort_order: sortOrder }
          : {}),
        ...(party ? { party } : {}),
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

// Change Order Review APIs
export async function createChangeOrderReview({
  contractId,
  changeOrderId,
  projectId,
  reviewData,
}) {
  const token = localStorage.getItem("token");
  const response = await api.post(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}/reviews`,
    reviewData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function fetchChangeOrderReviews({
  contractId,
  changeOrderId,
  projectId,
}) {
  const token = localStorage.getItem("token");
  const response = await api.get(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}/reviews`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function updateChangeOrderReview({
  contractId,
  changeOrderId,
  projectId,
  reviewId,
  reviewData,
}) {
  const token = localStorage.getItem("token");
  const response = await api.patch(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}/reviews/${reviewId}`,
    reviewData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function deleteChangeOrderReview({
  contractId,
  changeOrderId,
  projectId,
  reviewId,
}) {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}/reviews/${reviewId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}
